export const useDateTimeManager = () => {
  const getDateWithAddedDays = (days: number) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString().split("T")[0];
  };

  const convertSec = (totalSeconds: number | null): string => {
    if (totalSeconds === null || totalSeconds === undefined) return "00:00";
    if (totalSeconds <= 0) return "00:00"; // Handle zero or negative values if necessary

    let seconds = Math.floor(totalSeconds % 60);
    let minutes = Math.floor(totalSeconds / 60);
    let hours = "";

    if (minutes > 59) {
      hours = Math.floor(minutes / 60).toString();
      hours = +hours >= 10 ? hours.toString() : "0" + hours;
      minutes -= +hours * 60;
    }

    const formattedMinutes = minutes >= 10 ? minutes.toString() : "0" + minutes;
    const formattedSeconds = seconds >= 10 ? seconds.toString() : "0" + seconds;

    if (hours) {
      hours = hours.length === 1 ? "0" + hours : hours;
      return `${hours}:${formattedMinutes}:${formattedSeconds}`;
    }

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const convertFullSec = (totalSeconds: number) => {
    const totalMinutes = Math.floor(totalSeconds / 60);

    const seconds = totalSeconds % 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours >= 10 ? hours : "0" + hours}:${
      minutes >= 10 ? minutes : "0" + minutes
    }:${seconds >= 10 ? seconds : "0" + seconds}`;
  };

  const dateToPersian = (date: string) => {
    const dateFormat = new Date(date);
    return dateFormat.toLocaleDateString("fa-IR", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
  };

  return {
    getDateWithAddedDays,
    convertSec,
    convertFullSec,
    dateToPersian,
  };
};
